// Shared API configuration utility
// Intelligently determines the correct API base URL based on environment and hostname

export const getApiBaseUrl = () => {
  // If an explicit API URL is set in environment variables, ALWAYS use it
  // This ensures Staging/Preview deployments use their configured backend
  // instead of falling back to the hardcoded Production proxy in vercel.json
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'development') {
    // In local dev, auto-detect if env var is missing
    const hostname = window.location.hostname;

    // If accessing via Tailscale IP, use the same IP for backend
    if (hostname.match(/^100\.\d+\.\d+\.\d+$/)) {
      return `http://${hostname}:8000/api`;
    } else {
      // Default to localhost for local development
      return 'http://localhost:8000/api';
    }
  } else {
    // Fallback for production if no env var is set
    // This relies on vercel.json rewrites (which point to Prod)
    return '/api';
  }
};

export default getApiBaseUrl;
